module.exports = "/_next/static/images/customer-review-magdalena-min-040b67d5165e4e6d673c3a13e5db58dd.png.webp";